import React from 'react';
import {FormattedMessage} from "react-intl";
import {useFormikContext} from "formik";

import FormikInput from "components/input/new/FormikInput";

import {greyishBlue500} from "assets/jss/main";

function ReturnOnlyField(props) {
    const {values} = useFormikContext();

    return (
        <>
            <FormikInput
                type={'checkbox'}
                name={'returnOnly'}
                label={'shippingMethods.form.field.returnOnly.label'}
                noPadding={true}
            />
            {values.returnOnly && (
                <span style={{fontSize: '12px', color: greyishBlue500}}>
                    <FormattedMessage id={'shippingMethods.form.field.returnOnly.help'}/>
                </span>
            )}
        </>
    );
}

export default ReturnOnlyField;
